export default "__VITE_ASSET__DLowgcSa__"